import BlogNoSidebarContainer from "../../../../components/pages/blog/blogPage/BlogNoSidebar";

const BlogNoSidebar = () => {
  return <BlogNoSidebarContainer />;
};

export default BlogNoSidebar;
